/* esm.sh - @xobotyi/scrollbar-width@1.9.5 */
export * from "/*@xobotyi/scrollbar-width@1.9.5/esnext/scrollbar-width.mjs";
